import { io } from 'socket.io-client';
import wsProtocol from '@/js/wsProtocol';

const userSocket = io(`${wsProtocol}://${process.env.VUE_APP_EDITOR_BACKEND_HOST}`, {
    transports: ['websocket'],
    path: '/editor-users',
});

export default userSocket;
